<div
    class="tw-flex tw-flex-col sm:tw-flex-row tw-w-full tw-rounded-[10px] tw-overflow-hidden sm:tw-h-[210px] md:tw-h-[217px] lg:tw-h-[384px]"
>
    <!-- Content section - shows first on mobile, second on larger screens -->
    <div
        class="tw-order-1 sm:tw-order-2 tw-px-0 lg:tw-px-[40px] md:tw-px-[15px] tw-flex-1 tw-bg-transparent md:tw-bg-white tw-h-full tw-flex tw-items-center"
    >
        <div
            class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[14px] tw-py-[14px]"
        >
            <span
                class="tw-text-[14px] lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold tw-text-[#000000CC] tw-text-start"
                >{{ title }}</span
            >
            <span
                class="tw-text-[12px] lg:tw-text-[14px] md:tw-text-[12px] tw-leading-[14px] lg:tw-leading-[22px] md:tw-leading-[14px] tw-font-normal tw-text-[#000000CC] tw-text-start tw-whitespace-normal tw-break-words"
                >{{ description }}</span
            >

            <button
                (click)="openLink(); $event.stopPropagation()"
                type="button"
                [attr.ga-event-id]="'learn_more_' + slug + '_button_jc3_click'"
                [attr.ga-event-category]="'JC3 Button'"
                [attr.ga-event-label]="'Learn More Button Click'"
                ga-track="track"
                class="tw-px-[23px] tw-py-[9px] tw-bg-[#024B3F] tw-rounded-[30px] tw-flex-shrink-0 tw-cursor-pointer hover:tw-bg-[#036B56] tw-transition-colors"
            >
                <span
                    class="tw-text-white tw-text-[14px] tw-font-bold tw-leading-[10px] tw-pointer-events-none"
                    >{{ linkText }}</span
                >
            </button>
        </div>
    </div>
    <!-- Image section - shows second on mobile, first on larger screens -->
    <div
        class="tw-order-2 sm:tw-order-1 carousel-image sm:tw-flex-1 lg:tw-w-[553px] md:tw-w-[278px] tw-h-[217px] sm:tw-h-full tw-rounded-[10px] md:tw-rounded-r-none tw-overflow-hidden tw-relative"
    >
        <img
            [src]="desktop"
            [alt]="title"
            class="tw-absolute- tw-top-0- tw-left-0- tw-w-full tw-h-full tw-object-cover xl:tw-block tw-hidden"
        />
        <img
            [src]="portrait"
            [alt]="title"
            class="tw-absolute- tw-top-0- tw-left-0- tw-w-full tw-h-full tw-object-cover xl:tw-hidden md:tw-block tw-hidden"
        />
        <img
            [src]="mobile"
            [alt]="title"
            class="tw-absolute- tw-top-0- tw-left-0- tw-w-full tw-h-full tw-object-cover md:tw-hidden tw-block"
        />
    </div>
</div>
`
